import React from "react";
import {TabOwnProps, TabProps, ToggleButton, ToggleButtonGroup} from "@mui/material";
import {NavLink, useLocation} from "react-router-dom";
import Tooltip from "@mui/material/Tooltip";


export type LeftTabs = {
    path: string;
    label?: string;
    url: string;
} & TabOwnProps

type Props = {
    tabs: TabProps<any, LeftTabs>[];
}

const IconTabs = ({tabs}: Props) => {
    const location = useLocation();

    return (
        <ToggleButtonGroup exclusive>
            {
                tabs?.map(({label, icon, ...props}, ind) =>
                    <Tooltip
                        key={ind}
                        title={label ?? ''}
                        placement="bottom"
                        disableInteractive
                    >
                        <span data-testid={props.testId}>
                            <NavLink
                                to={`${props.url}${location.search}`}
                                className={({isActive, isPending}) =>
                                    isPending ? "pending" : isActive ? "active" : ""
                                }

                            >
                                {({isActive, isPending}) => (
                                    <ToggleButton
                                        value={ind}
                                        selected={isActive}
                                    >
                                        {icon}
                                    </ToggleButton>
                                )}
                            </NavLink>
                        </span>
                    </Tooltip>
                )
            }
        </ToggleButtonGroup>
    );
}

export default IconTabs;